// @flow
import {useUserType} from '../../auth/utils';
import {useStoreBusinessModel} from '../../store/utils';
import {useStoreCountry} from '../../country/utils';
import {useCurrentUserHasAllFeatures} from './useFeatures';
import type {NavigationItemConfig} from '../types';

export function useItemVisibility(item: NavigationItemConfig): boolean {
  const {userType} = useUserType();
  const businessModel = useStoreBusinessModel();
  const country = useStoreCountry();
  const countryCode = country ? country.code : null;

  const hasAllRequired = useCurrentUserHasAllFeatures(
    item.requiredFeatures || []
  );

  if (item.hide) return false;

  if (
    item.onlyForBusinessModels &&
    !item.onlyForBusinessModels.includes(businessModel)
  ) {
    return false;
  }

  if (
    item.onlyForCountries &&
    countryCode &&
    !item.onlyForCountries.includes(countryCode)
  ) {
    return false;
  }

  if (item.requiredFeatures && !hasAllRequired) {
    return false;
  }

  if (userType && item.onlyForRoles && !item.onlyForRoles.includes(userType)) {
    return false;
  }

  return true;
}

/**
 * Hook to determine if an item needs an upsell badge
 */
export function useItemNeedsUpSell(item: NavigationItemConfig): boolean {
  const hasAllFeatures = useCurrentUserHasAllFeatures(
    item.upSellIfMissingFeatures || []
  );

  if (!item.upSellIfMissingFeatures) return false;

  return !hasAllFeatures;
}
